import React from 'react';

const COLORS = {
  error:   { bg: '#fef2f2', border: '#fecaca', text: '#dc2626' },
  success: { bg: '#f0fdf4', border: '#bbf7d0', text: '#16a34a' },
  info:    { bg: '#eff6ff', border: '#bfdbfe', text: '#2563eb' },
  warning: { bg: '#fffbeb', border: '#fde68a', text: '#d97706' },
};

export default function Alert({ type = 'info', children, style }) {
  const c = COLORS[type];
  return (
    <div style={{
      background: c.bg, border: `1px solid ${c.border}`, borderRadius: 'var(--radius-sm)',
      padding: '12px 16px', color: c.text,
      fontSize: 'var(--font-size-sm)', marginBottom: 16, lineHeight: 1.5,
      ...style,
    }}>
      {children}
    </div>
  );
}
